export const a11yHiddenSvgProps = {
    // Hides element from a11y tree
    'aria-hidden': true,
};
